import { Injectable, type Provider } from '@angular/core';
import { ListStateService } from '@modules/common/components/list/list-state.service';
import { FormsKpListState, type FormsKpItem, type FormsListSortField } from '../types/forms-kp-list-state';

@Injectable()
export class FormsKpListStateService extends ListStateService<FormsKpItem, FormsListSortField, FormsKpListState> {
  public readonly state = new FormsKpListState();

  public static providers(): Provider[] {
    return [FormsKpListStateService, { provide: ListStateService, useExisting: FormsKpListStateService, multi: true }];
  }
}
